import React, { FC } from 'react'
import { Box, Slider, TextField, Typography } from '@mui/material'

type Props = {
  label?: string
  minValue: number
  maxValue: number
  value: number
  step: number
  onSliderChange: (_event: Event, newValue: number | number[]) => void
  onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onInputBlur: () => void
}

export const SliderNumberInput: FC<Props> = props => {
  const { minValue, maxValue, onInputBlur, onInputChange, value, step, onSliderChange, label } =
    props

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const currentNumber = event.target.value

    if (currentNumber !== '' && Number(currentNumber) > maxValue) {
      return
    }

    onInputChange(event)
  }

  return (
    <Box sx={{ mb: 3 }}>
      {label && (
        <Typography sx={{ mb: 1 }} variant='body2'>
          {label}
        </Typography>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Slider
          max={maxValue}
          min={minValue}
          step={step}
          sx={{ flex: 1 }}
          value={value}
          onChange={onSliderChange}
        />
        <TextField
          size='small'
          sx={{ width: 80 }}
          type='number'
          value={value}
          inputProps={{
            min: minValue,
            max: maxValue,
            step,
          }}
          onBlur={onInputBlur}
          onChange={handleInputChange}
        />
      </Box>
    </Box>
  )
}
